/* eslint-disable no-magic-numbers */
export const emiNumberFormat = value => {
    if (value >= 1000000) {
        return `${Math.floor(value / 100000) / 10 } jt`;
    }
    return `${(value / 1000).toString() } rb`;
};
